export const POSITIONS = [
  "Goalkeeper",
  "Center Back",
  "Full Back",
  "Defensive Midfielder",
  "Central Midfielder",
  "Attacking Midfielder",
  "Winger",
  "Striker",
];

export const FOOT = ["Right", "Left", "Both"];

// Africa first — the platform's core focus and heritage.
export const AFRICAN_COUNTRIES = [
  // ─── AFRICA (primary focus) ───
  "Algeria", "Angola", "Benin", "Botswana", "Burkina Faso", "Burundi", "Cameroon", "Cape Verde",
  "Central African Republic", "Chad", "Comoros", "Congo", "DR Congo", "Djibouti", "Egypt",
  "Equatorial Guinea", "Eritrea", "Eswatini", "Ethiopia", "Gabon", "Gambia", "Ghana", "Guinea",
  "Guinea-Bissau", "Ivory Coast", "Kenya", "Lesotho", "Liberia", "Libya", "Madagascar", "Malawi",
  "Mali", "Mauritania", "Mauritius", "Morocco", "Mozambique", "Namibia", "Niger", "Nigeria",
  "Rwanda", "Sao Tome and Principe", "Senegal", "Seychelles", "Sierra Leone", "Somalia",
  "South Africa", "South Sudan", "Sudan", "Tanzania", "Togo", "Tunisia", "Uganda", "Zambia", "Zimbabwe",

  // ─── NORTH AMERICA ───
  "Canada", "Costa Rica", "Cuba", "Dominican Republic", "El Salvador", "Guatemala", "Haiti",
  "Honduras", "Jamaica", "Mexico", "Nicaragua", "Panama", "Trinidad and Tobago", "United States",

  // ─── SOUTH AMERICA ───
  "Argentina", "Bolivia", "Brazil", "Chile", "Colombia", "Ecuador", "Guyana", "Paraguay",
  "Peru", "Suriname", "Uruguay", "Venezuela",

  // ─── EUROPE ───
  "Albania", "Austria", "Belgium", "Bosnia and Herzegovina", "Bulgaria", "Croatia", "Cyprus",
  "Czech Republic", "Denmark", "England", "Estonia", "Finland", "France", "Georgia", "Germany",
  "Greece", "Hungary", "Iceland", "Ireland", "Italy", "Latvia", "Lithuania", "Luxembourg",
  "Malta", "Moldova", "Montenegro", "Netherlands", "North Macedonia", "Northern Ireland",
  "Norway", "Poland", "Portugal", "Romania", "Russia", "Scotland", "Serbia", "Slovakia",
  "Slovenia", "Spain", "Sweden", "Switzerland", "Turkey", "Ukraine", "Wales",
];

export const PASSPORT_STATUS = ["Valid", "Applied", "Expired", "None"];
